export enum EligibilityResponseStatus  {
    Eligible = 1,
    NotActive = 2,
    NotCovered = 3,
    NotDirectBilling = 4,
    OutNetwork = 5,
    LimitExhausted = 6,
    CoverageSuspended = 7,
    ProviderContractSuspended = 8,
}